
// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";

// import dashboardHeroImage from "../../../assets/DashboardHero.png";

// const humanText = "Human";
// const capitalText = "Capital Management.";

// const LandingHero = () => {

//   const [typedHuman, setTypedHuman] = useState("");
//   const [typedCapital, setTypedCapital] = useState("");

//   /* TYPEWRITER */

//   useEffect(() => {

//     let humanIndex = 0;

//     const humanInterval = setInterval(() => {

//       setTypedHuman(
//         humanText.slice(0, humanIndex + 1)
//       );

//       humanIndex++;

//       if (humanIndex === humanText.length) {

//         clearInterval(humanInterval);

//         let capitalIndex = 0;

//         const capitalInterval = setInterval(() => {

//           setTypedCapital(
//             capitalText.slice(0, capitalIndex + 1)
//           );

//           capitalIndex++;

//           if (capitalIndex === capitalText.length) {
//             clearInterval(capitalInterval);
//           }

//         }, 60);

//       }

//     }, 90);

//     return () => clearInterval(humanInterval);

//   }, []);

//   return (

//     <motion.section
//       className="landing-hero-wrapper"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 1 }}
//     >



//       {/* LEFT CONTENT */}

//       <div className="landing-hero-left">

//         {/* SMALL TITLE */}

//         <motion.p
//           className="landing-small-title"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{
//             delay: 0.2,
//             duration: 0.8,
//             ease: "easeOut",
//           }}
//         >

//           Enterprise HRMS Platform

//         </motion.p>

//         {/* MAIN TITLE */}

//         <motion.div
//           className="landing-main-title-wrapper"
//           initial={{ opacity: 0, y: 40 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{
//             delay: 0.4,
//             duration: 1,
//             ease: "easeOut",
//           }}
//         >

//           <h1 className="landing-main-title">

//             <span className="landing-black-text">

//               {typedHuman}

//             </span>

//             <span className="landing-cursor">

//             </span>

//             <br />

//             <span className="landing-blue-text">

//               {typedCapital}

//             </span>

//           </h1>

//           {/* TAGLINE */}

//           <motion.div
//             className="landing-tagline-wrapper"
//             initial={{
//               opacity: 0,
//               x: -30,
//             }}
//             animate={{
//               opacity: 1,
//               x: 0,
//             }}
//             transition={{
//               delay: 2,
//               duration: 0.8,
//             }}
//           >

//             <div className="landing-tagline-line"></div>

//             <p className="landing-tagline">

//               Built for

//               <span>
//                 {" "}Modern Use
//               </span>

//             </p>

//           </motion.div>

//         </motion.div>

//         {/* DESCRIPTION */}

//         <motion.p
//           className="landing-hero-description"
//           initial={{
//             opacity: 0,
//             y: 35,
//           }}
//           animate={{
//             opacity: 1,
//             y: 0,
//           }}
//           transition={{
//             delay: 2.3,
//             duration: 0.9,
//           }}
//         >

//           Streamline attendance, payroll, leave management,
//           reimbursements, employee workflows, and performance
//           tracking in one intelligent platform.

//         </motion.p>

//         {/* BUTTONS */}

//         <motion.div
//           className="landing-hero-buttons"
//           initial={{
//             opacity: 0,
//             y: 35,
//           }}
//           animate={{
//             opacity: 1,
//             y: 0,
//           }}
//           transition={{
//             delay: 2.5,
//             duration: 0.8,
//           }}
//         >

//           <motion.button
//             className="landing-primary-button"
//             whileHover={{
//               scale: 1.05,
//               y: -3,
//             }}
//             whileTap={{
//               scale: 0.96,
//             }}
//           >

//             Get Started

//           </motion.button>

//           <motion.button
//             className="landing-secondary-button"
//             whileHover={{
//               scale: 1.05,
//               y: -3,
//             }}
//             whileTap={{
//               scale: 0.96,
//             }}
//           >

//             Watch Demo

//           </motion.button>

//         </motion.div>

//       </div>

//       {/* RIGHT SIDE */}

//       <motion.div
//         className="landing-hero-right"
//         initial={{
//           opacity: 0,
//           scale: 0.88,
//           x: 60,
//         }}
//         animate={{
//           opacity: 1,
//           scale: 1,
//           x: 0,
//         }}
//         transition={{
//           duration: 1.2,
//           ease: "easeOut",
//         }}
//       >

//         <motion.div
//           className="landing-dashboard-preview"
//           animate={{
//             y: [0, -12, 0],
//           }}
//           transition={{
//             repeat: Infinity,
//             duration: 5,
//             ease: "easeInOut",
//           }}
//         >

//           <motion.img
//             src={dashboardHeroImage}
//             alt="dashboard"
//             className="landing-dashboard-image"
//             whileHover={{
//               scale: 1.02,
//             }}
//             transition={{
//               duration: 0.4,
//             }}
//           />

//         </motion.div>

//       </motion.div>

//     </motion.section>

//   );
// };

// export default LandingHero;












// import React, { useEffect } from "react";

// export default function Home() {

//   useEffect(() => {

//     const existingScript = document.querySelector(

//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'

//     );

//     if (!existingScript) {

//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =

//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       document.body.appendChild(script);

//     }

//   }, []);

//   return (
// <div

//       style={{

//         width: "100%",

//         height: "100VH",

//         background: "#000",

//         position: "relative",

//         overflow: "hidden",

//       }}
// >

//       {/* NAVBAR SPACE (optional spacing area) */}
// <div

//         style={{

//           height: "70px", // adjust if your navbar height is different

//         }}

//       />

//       {/* CENTER ROBOT */}
// <div

//         style={{

//           position: "absolute",

//           top: "25%",

//           left: "50%",

//           transform: "translate(-50%, -45%) scale(1.5)",

//           width: "900px",

//           height: "900px",

//         }}
// >
// <spline-viewer

//           url="https://prod.spline.design/5xI-2MtVO6dMsVsX/scene.splinecode"

//           style={{

//             width: "100%",

//             height: "100%",

//           }}
// ></spline-viewer>
// </div>
// </div>

//   );

// }








// import React, { useEffect } from "react";

// const SplineRobot = () => {

//   useEffect(() => {

//   const existingScript = document.querySelector(
//     'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//   );

//   if (!existingScript) {

//     const script = document.createElement("script");

//     script.type = "module";

//     script.src =
//       "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//     document.body.appendChild(script);
//   }

//   // REMOVE SPLINE LOGO
//   const interval = setInterval(() => {

//     const viewer = document.querySelector("spline-viewer");

//     if (viewer && viewer.shadowRoot) {

//       const logo =
//         viewer.shadowRoot.querySelector("#logo") ||
//         viewer.shadowRoot.querySelector(".logo") ||
//         viewer.shadowRoot.querySelector('[class*="logo"]');

//       if (logo) {
//         logo.style.display = "none";
//       }
//     }

//   }, 500);

//   return () => clearInterval(interval);

// }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//       }}
//     >

//       {/* HIDE SPLINE LOGO */}
//       <style>
//         {`
//           spline-viewer::part(logo) {
//             display: none !important;
//           }
//         `}
//       </style>

//       <spline-viewer
//         url="https://prod.spline.design/tjQVUUwNyBLdEAaq/scene.splinecode"
//         style={{
//           width: "100%",
//           height: "100%",
//         }}
//       ></spline-viewer>

//     </div>
//   );
// };

// export default SplineRobot;











// robot


// import React, { useEffect, useState } from "react";

// const SplineRobot = () => {

//   const [showSpline, setShowSpline] = useState(false);

//   useEffect(() => {

//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {

//       const viewerCheck = setInterval(() => {

//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {

//           const logo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (logo) {
//             logo.remove(); // COMPLETELY REMOVE
//           }

//           // SHOW VIEWER ONLY AFTER LOGO REMOVED
//           setShowSpline(true);

//           clearInterval(viewerCheck);
//         }

//       }, 100);

//     };

//     if (!existingScript) {

//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);

//     } else {
//       startSpline();
//     }

//   }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//       }}
//     >

//       {/* SPLINE VIEWER */}

//       <div
//         style={{
//           width: "100%",
//           height: "100%",
//           opacity: showSpline ? 1 : 0,
//           transition: "opacity 0.5s ease",
//         }}
//       >
//         <spline-viewer
//           url="https://prod.spline.design/tjQVUUwNyBLdEAaq/scene.splinecode"
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         ></spline-viewer>
//       </div>

//     </div>
//   );
// };

// export default SplineRobot;










// import React, { useEffect, useState } from "react";

// const SplineRobot = () => {
//   const [showSpline, setShowSpline] = useState(false);

//   useEffect(() => {
//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {
//       const viewerCheck = setInterval(() => {
//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {
//           // REMOVE SPLINE LOGO
//           const logo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (logo) {
//             logo.remove();
//           }

//           setShowSpline(true);

//           clearInterval(viewerCheck);
//         }
//       }, 100);
//     };

//     if (!existingScript) {
//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);
//     } else {
//       startSpline();
//     }
//   }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >
//       {/* LEFT TEXT CONTENT */}
//       <div
//         style={{
//           position: "absolute",
//           left: "0",
//           top: "0",
//           width: "45%",
//           height: "100%",
//           zIndex: 10,
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           paddingLeft: "80px",
//           background:
//             "linear-gradient(to right, rgba(0,0,0,0.92), rgba(0,0,0,0.65), transparent)",
//           backdropFilter: "blur(8px)",
//         }}
//       >
//         <h1
//           style={{
//             color: "#fff",
//             fontSize: "72px",
//             lineHeight: "1.1",
//             fontWeight: "700",
//             margin: "0",
//             letterSpacing: "-2px",
//           }}
//         >
//           Human <br />
//           <span style={{ color: "#55FF60" }}>Capital</span> Management
//         </h1>

//         <p
//           style={{
//             color: "#55FF60",
//             fontSize: "22px",
//             marginTop: "24px",
//             maxWidth: "500px",
//             lineHeight: "1.6",
//             marginLeft: "4px",

//           }}
//         >
//           Built for modern use
//         </p>
//       </div>

//       {/* SPLINE ROBOT */}
//       <div
//         style={{
//           position: "absolute",
//           right: "-12%",
//           top: "0",
//           width: "75%",
//           height: "100%",
//           opacity: showSpline ? 1 : 0,
//           transition: "opacity 0.5s ease",
//         }}
//       >
//         <spline-viewer
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         ></spline-viewer>
//       </div>
//     </div>
//   );
// };

// export default SplineRobot;

















// import React, { useEffect, useState } from "react";
// import logo from "../../../assets/logo-white-r.png"; // UPDATE PATH IF NEEDED

// const SplineRobot = () => {
//   const [showSpline, setShowSpline] = useState(false);

//   useEffect(() => {
//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {
//       const viewerCheck = setInterval(() => {
//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {
//           // REMOVE SPLINE LOGO
//           const logo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (logo) {
//             logo.remove();
//           }

//           setShowSpline(true);

//           clearInterval(viewerCheck);
//         }
//       }, 100);
//     };

//     if (!existingScript) {
//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);
//     } else {
//       startSpline();
//     }
//   }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >
//       {/* TOP LEFT LOGO */}
//       <div
//         style={{
//           position: "absolute",
//           top: "30px",
//           left: "50px",
//           zIndex: 20,
//         }}
//       >
//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: "180px",
//             height: "190px",
//             objectFit: "contain",
//             marginTop: "-25px"
//           }}
//         />
//       </div>

//       {/* LEFT TEXT CONTENT */}
//       <div
//         style={{
//           position: "absolute",
//           left: "0",
//           top: "0",
//           width: "45%",
//           height: "100%",
//           zIndex: 10,
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           paddingLeft: "80px",
//           background:
//             "linear-gradient(to right, rgba(0,0,0,0.92), rgba(0,0,0,0.65), transparent)",
//           backdropFilter: "blur(8px)",
//         }}
//       >
//         <h1
//           style={{
//             color: "#fff",
//             fontSize: "72px",
//             lineHeight: "1.1",
//             fontWeight: "700",
//             margin: "0",
//             letterSpacing: "-2px",
//           }}
//         >
//           Human <br />
//           <span style={{ color: "#55FF60" }}>Capital</span> Management
//         </h1>

//         <p
//           style={{
//             color: "#55FF60",
//             fontSize: "22px",
//             marginTop: "24px",
//             maxWidth: "500px",
//             lineHeight: "1.6",
//             marginLeft: "400px",
//           }}
//         >
//           Built for modern use
//         </p>
//       </div>

//       {/* SPLINE ROBOT */}
//       <div
//         style={{
//           position: "absolute",
//           right: "-12%",
//           top: "0",
//           width: "75%",
//           height: "100%",
//           opacity: showSpline ? 1 : 0,
//           transition: "opacity 0.5s ease",
//         }}
//       >
//         <spline-viewer
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         ></spline-viewer>
//       </div>
//     </div>
//   );
// };

// export default SplineRobot;











// import React, { useEffect, useState } from "react";
// import logo from "../../../assets/logo-white-r.png";

// const SplineRobot = () => {
//   const [showSpline, setShowSpline] = useState(false);

//   useEffect(() => {
//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {
//       const viewerCheck = setInterval(() => {
//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {
//           // REMOVE SPLINE LOGO
//           const logo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (logo) {
//             logo.remove();
//           }

//           setShowSpline(true);

//           clearInterval(viewerCheck);
//         }
//       }, 100);
//     };

//     if (!existingScript) {
//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);
//     } else {
//       startSpline();
//     }
//   }, []);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >
//       {/* SPLINE ROBOT RIGHT SIDE */}
//       {/* SPLINE ROBOT RIGHT SIDE */}
// <div
//   style={{
//     position: "absolute",

//     // RESPONSIVE POSITION
//     right: window.innerWidth < 1200 ? "-45%" : "-30%",

//     top: "10%",
//     width: "100%",
//     height: "100%",
//     opacity: showSpline ? 1 : 0,
//     transition: "opacity 0.5s ease",
//     zIndex: 1,
//   }}
// >
//   <spline-viewer
//     url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//     style={{
//       width: "100%",
//       height: "100%",
//     }}
//   ></spline-viewer>
// </div>

//       {/* LEFT SIDE DARK OVERLAY */}
//       <div
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           width: "50%",
//           height: "100%",
//           // background:
//           // "linear-gradient(to right, rgba(0,0,0,0.97), rgba(0,0,0,0.85), rgba(0,0,0,0.45), transparent)",
//           // backdropFilter: "blur(10px)",
//           zIndex: 5,
//         }}
//       />

//       {/* TOP LEFT LOGO */}
//       <div
//         style={{
//           position: "absolute",
//           top: "20px",
//           left: "45px",
//           zIndex: 20,
//         }}
//       >
//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: "180px",
//             height: "190px",
//             objectFit: "contain",
//           }}
//         />
//       </div>


//       {/* LEFT TEXT CONTENT */}
//      {/* LEFT TEXT CONTENT */}
// <div
//   style={{
//     position: "absolute",
//     left: "0",
//     top: "0",
//     width: "100%",
//     maxWidth: "700px",
//     height: "100%",
//     zIndex: 10,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     paddingLeft: "5vw",
//     paddingRight: "20px",

//     background: "transparent",
//     backdropFilter: "none",
//   }}
// >
//   <h1
//     style={{
//       color: "#fff",

//       // RESPONSIVE FONT
//       fontSize: "clamp(42px, 6vw, 78px)",

//       lineHeight: "1.05",
//       fontWeight: "800",
//       margin: "0",
//       letterSpacing: "-2px",

//       // PREVENT TEXT BREAK ISSUE
//       wordBreak: "break-word",
//     }}
//   >
//     Human <br />
//     <span style={{ color: "#55FF60" }}>Capital</span>{" "}
//     <span style={{ display: "inline-block" }}>
//       Management
//     </span>
//   </h1>

//   <p
//     style={{
//       color: "#55FF60",

//       // RESPONSIVE TEXT
//       fontSize: "clamp(16px, 2vw, 22px)",

//       marginTop: "28px",
//       lineHeight: "1.6",
//       fontWeight: "500",
//       letterSpacing: "1px",
//     }}
//   >
//     Built for modern use
//   </p>
// </div>
//     </div>
//   );
// };

// export default SplineRobot;











// import React, { useEffect, useState } from "react";
// import logo from "../../../assets/logo-white-r.png";

// const SplineRobot = () => {

//   const [showSpline, setShowSpline] = useState(false);

//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   useEffect(() => {

//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);

//   }, []);

//   useEffect(() => {

//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {

//       const viewerCheck = setInterval(() => {

//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {

//           const splineLogo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (splineLogo) {
//             splineLogo.remove();
//           }

//           setShowSpline(true);

//           clearInterval(viewerCheck);
//         }

//       }, 100);

//     };

//     if (!existingScript) {

//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);

//     } else {

//       startSpline();

//     }

//   }, []);

//   const isMobile = screenWidth < 768;

//   return (

//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >

//       {/* SPLINE */}

//       <div
//         style={{
//           position: "absolute",

//           right: isMobile ? "-120%" : screenWidth < 1200 ? "-45%" : "-30%",

//           top: isMobile ? "18%" : "10%",

//           width: isMobile ? "220%" : "100%",

//           height: "100%",

//           opacity: showSpline ? 1 : 0,

//           transition: "opacity 0.5s ease",

//           zIndex: 1,
//         }}
//       >

//         <spline-viewer
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         ></spline-viewer>

//       </div>

//       {/* DARK OVERLAY */}

//       <div
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,

//           width: isMobile ? "100%" : "50%",

//           height: "100%",

//           background: isMobile
//             ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.5), transparent)"
//             : "linear-gradient(to right, rgba(0,0,0,0.92), rgba(0,0,0,0.55), transparent)",

//           zIndex: 5,
//         }}
//       />

//       {/* LOGO */}

//       <div
//         style={{
//           position: "absolute",

//           top: isMobile ? "12px" : "20px",

//           left: isMobile ? "12px" : "45px",

//           zIndex: 20,
//         }}
//       >

//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: isMobile ? "110px" : "180px",

//             height: isMobile ? "120px" : "190px",

//             objectFit: "contain",
//           }}
//         />

//       </div>

//       {/* TEXT CONTENT */}

//       <div
//         style={{
//           position: "absolute",

//           left: 0,
//           top: 0,

//           width: "100%",

//           maxWidth: isMobile ? "100%" : "700px",

//           height: "100%",

//           zIndex: 10,

//           display: "flex",

//           flexDirection: "column",

//           justifyContent: isMobile ? "flex-end" : "center",

//           paddingLeft: isMobile ? "22px" : "5vw",

//           paddingRight: isMobile ? "22px" : "20px",

//           paddingBottom: isMobile ? "120px" : "0",
//         }}
//       >

//         <h1
//           style={{
//             color: "#fff",

//             fontSize: isMobile
//               ? "48px"
//               : "clamp(42px, 6vw, 78px)",

//             lineHeight: "1",

//             fontWeight: "800",

//             margin: 0,

//             letterSpacing: "-2px",

//             wordBreak: "break-word",
//           }}
//         >

//           Human <br />

//           <span style={{ color: "#55FF60" }}>
//             Capital
//           </span>

//           <br />

//           Management

//         </h1>

//         <p
//           style={{
//             color: "#55FF60",

//             fontSize: isMobile ? "16px" : "clamp(16px, 2vw, 22px)",

//             marginTop: "22px",

//             lineHeight: "1.6",

//             fontWeight: "500",

//             letterSpacing: "1px",
//             marginLeft: isMobile ? "0" : "300px",
//           }}
//         >

//           Built for modern use

//         </p>

//       </div>

//     </div>

//   );

// };

// export default SplineRobot;










// import React, { useEffect, useState } from "react";
// import logo from "../../../assets/logo-white-r.png";

// const SplineRobot = () => {

//   const [showSpline, setShowSpline] = useState(false);

//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   const [typedText, setTypedText] = useState("");

//   const phrases = [
//     "Built for modern HR",
//     "Built for enterprises",
//     "Built for AI automation",
//     "Built for scalable teams",
//   ];

//   useEffect(() => {

//     let phraseIndex = 0;
//     let charIndex = 0;

//     const type = () => {

//       const currentPhrase = phrases[phraseIndex];

//       if (charIndex <= currentPhrase.length) {

//         setTypedText(currentPhrase.substring(0, charIndex));

//         charIndex++;

//       } else {

//         setTimeout(() => {

//           charIndex = 0;

//           phraseIndex = (phraseIndex + 1) % phrases.length;

//         }, 1500);

//       }

//     };

//     const interval = setInterval(type, 80);

//     return () => clearInterval(interval);

//   }, []);

//   useEffect(() => {

//     const handleResize = () => {
//       setScreenWidth(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);

//   }, []);

//   useEffect(() => {

//     const existingScript = document.querySelector(
//       'script[src="https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js"]'
//     );

//     const startSpline = () => {

//       const viewerCheck = setInterval(() => {

//         const viewer = document.querySelector("spline-viewer");

//         if (viewer && viewer.shadowRoot) {

//           const splineLogo =
//             viewer.shadowRoot.querySelector("#logo") ||
//             viewer.shadowRoot.querySelector(".logo") ||
//             viewer.shadowRoot.querySelector('[class*="logo"]');

//           if (splineLogo) {
//             splineLogo.remove();
//           }

//           setShowSpline(true);

//           clearInterval(viewerCheck);

//         }

//       }, 100);

//     };

//     if (!existingScript) {

//       const script = document.createElement("script");

//       script.type = "module";

//       script.src =
//         "https://unpkg.com/@splinetool/viewer@1.12.92/build/spline-viewer.js";

//       script.onload = () => {
//         startSpline();
//       };

//       document.body.appendChild(script);

//     } else {

//       startSpline();

//     }

//   }, []);

//   const isMobile = screenWidth < 768;

//   return (

//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >

//       {/* GREEN GLOW */}

//       <div
//         style={{
//           position: "absolute",
//           width: isMobile ? "280px" : "550px",
//           height: isMobile ? "280px" : "550px",
//           background: "#55FF60",
//           borderRadius: "50%",
//           filter: "blur(180px)",
//           opacity: 0.12,
//           right: "10%",
//           top: "15%",
//           zIndex: 0,
//         }}
//       />

//       {/* SPLINE */}

//       <div
//         style={{
//           position: "absolute",

//           right: isMobile ? "-120%" : screenWidth < 1200 ? "-45%" : "-30%",

//           top: isMobile ? "18%" : "-25%",

//           width: isMobile ? "220%" : "150%",

//           height: "140%",

//           opacity: showSpline ? 1 : 0,

//           transition: "opacity 0.5s ease",

//           zIndex: 1,
//         }}
//       >

//         <spline-viewer
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "140%",
//             height: "140%",
//             transform: "scale(1.5)",
//           }}
//         ></spline-viewer>

//       </div>

//       {/* DARK OVERLAY */}

//       <div
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,

//           width: isMobile ? "100%" : "50%",

//           height: "100%",

//           background: isMobile
//             ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.5), transparent)"
//             : "linear-gradient(to right, rgba(0,0,0,0.92), rgba(0,0,0,0.55), transparent)",

//           zIndex: 5,
//         }}
//       />

//       {/* LOGO */}

//       <div
//         style={{
//           position: "absolute",

//           top: isMobile ? "12px" : "20px",

//           left: isMobile ? "12px" : "45px",

//           zIndex: 20,
//         }}
//       >

//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: isMobile ? "110px" : "180px",

//             height: isMobile ? "120px" : "110px",

//             objectFit: "contain",
//           }}
//         />

//       </div>

//       {/* TEXT CONTENT */}

//       <div
//         style={{
//           position: "absolute",

//           left: 0,
//           top: 0,

//           width: "100%",

//           maxWidth: isMobile ? "100%" : "700px",

//           height: "100%",

//           zIndex: 10,

//           display: "flex",

//           flexDirection: "column",

//           justifyContent: isMobile ? "flex-end" : "center",

//           paddingLeft: isMobile ? "22px" : "5vw",

//           paddingRight: isMobile ? "22px" : "20px",

//           paddingBottom: isMobile ? "120px" : "0",
//         }}
//       >

//         <h1
//           style={{
//             color: "#fff",

//             fontSize: isMobile
//               ? "48px"
//               : "clamp(42px, 6vw, 78px)",

//             lineHeight: "1",

//             fontWeight: "800",

//             margin: 0,

//             letterSpacing: "-2px",

//             wordBreak: "break-word",
//           }}
//         >

//           Human <br />

//           <span
//             style={{
//               background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//             }}
//           >
//             Capital
//           </span>

//           <br />

//           Management

//         </h1>

//         <p
//           style={{
//             color: "#55FF60",

//             fontSize: isMobile ? "16px" : "clamp(16px, 2vw, 22px)",

//             marginTop: "22px",

//             lineHeight: "1.6",

//             fontWeight: "500",

//             letterSpacing: "1px",

//             minHeight: "32px",
//           }}
//         >

//           {typedText}

//         </p>

//         {/* CTA BUTTONS */}

//         <div
//           style={{
//             display: "flex",
//             gap: "18px",
//             marginTop: "35px",
//             flexWrap: "wrap",
//           }}
//         >

//           <button
//             style={{
//               padding: "16px 34px",
//               borderRadius: "999px",
//               border: "none",
//               background: "#55FF60",
//               color: "#000",
//               fontWeight: "700",
//               fontSize: "16px",
//               cursor: "pointer",
//               boxShadow: "0 0 30px rgba(85,255,96,0.35)",
//             }}
//           >
//             Get Started
//           </button>

//           <button
//             style={{
//               padding: "16px 34px",
//               borderRadius: "999px",
//               border: "1px solid rgba(255,255,255,0.15)",
//               background: "rgba(255,255,255,0.05)",
//               color: "#fff",
//               fontWeight: "600",
//               fontSize: "16px",
//               cursor: "pointer",
//               backdropFilter: "blur(10px)",
//             }}
//           >
//             Watch Demo
//           </button>

//         </div>

//         {/* STATS */}

//         <div
//           style={{
//             display: "flex",
//             gap: isMobile ? "24px" : "42px",
//             marginTop: "55px",
//             flexWrap: "wrap",
//           }}
//         >

//           {
//             [
//               ["500+", "Companies"],
//               ["98%", "Automation"],
//               ["24/7", "AI Support"],
//               ["50+", "Employees"],
//             ].map((item, index) => (

//               <div key={index}>

//                 <h3
//                   style={{
//                     color: "#55FF60",
//                     margin: 0,
//                     fontSize: isMobile ? "22px" : "30px",
//                   }}
//                 >
//                   {item[0]}
//                 </h3>

//                 <p
//                   style={{
//                     color: "rgba(255,255,255,0.65)",
//                     marginTop: "6px",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {item[1]}
//                 </p>

//               </div>

//             ))
//           }

//         </div>

//       </div>

//       {/* SCROLL INDICATOR */}

//       <div
//         style={{
//           position: "absolute",
//           bottom: "24px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           color: "#55FF60",
//           fontSize: "14px",
//           letterSpacing: "2px",
//           zIndex: 20,
//           opacity: 0.8,
//           animation: "bounce 2s infinite",
//         }}
//       >
//         {/* ↓ SCROLL TO EXPLORE */}
//       </div>

//     </div>

//   );

// };

// export default SplineRobot;
















// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for AI automation",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   /* Typing animation - optimized */

//   useEffect(() => {
//     let timeout;

//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();

//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   /* Resize optimized */

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);

//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <section
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >
//       {/* Glow */}
//       <div
//         style={{
//           position: "absolute",
//           width: isMobile ? "220px" : "420px",
//           height: isMobile ? "220px" : "420px",
//           background: "#55FF60",
//           borderRadius: "50%",
//           filter: "blur(140px)",
//           opacity: 0.1,
//           right: "10%",
//           top: "15%",
//           zIndex: 0,
//           pointerEvents: "none",
//         }}
//       />

//       {/* Spline */}
//       <div
//         style={{
//           position: "absolute",
//           right: isMobile ? "-80%" : "-18%",
//           top: isMobile ? "20%" : "-8%",
//           width: isMobile ? "170%" : "95%",
//           height: "100%",
//           zIndex: 1,
//           pointerEvents: "none",
//         }}
//       >
//         <spline-viewer
//           loading-anim-type="none"
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "120%",
//             height: "150%",
//             transform: isMobile ? "scale(0.95)" : "scale(1.05)",
//           }}
//         />
//       </div>

//       {/* Overlay */}
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: isMobile ? "100%" : "55%",
//           background: isMobile
//             ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//             : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//           zIndex: 5,
//           pointerEvents: "none",
//         }}
//       />

//       {/* Logo */}
//       <div
//         style={{
//           position: "absolute",
//           top: isMobile ? "12px" : "20px",
//           left: isMobile ? "12px" : "45px",
//           zIndex: 20,
//         }}
//       >
//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: isMobile ? "110px" : "170px",
//             height: "auto",
//             objectFit: "contain",
//           }}
//         />
//       </div>

//       {/* Content */}
//       <div
//         style={{
//           position: "relative",
//           zIndex: 10,
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: isMobile ? "flex-end" : "center",
//           paddingLeft: isMobile ? "22px" : "5vw",
//           paddingRight: "20px",
//           paddingBottom: isMobile ? "100px" : "0",
//           maxWidth: "700px",
//         }}
//       >
//         <h1
//           style={{
//             color: "#fff",
//             fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//             lineHeight: 1,
//             fontWeight: 800,
//             letterSpacing: "-2px",
//           }}
//         >
//           Human <br />
//           <span
//             style={{
//               background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//             }}
//           >
//             Capital
//           </span>
//           <br />
//           Management
//         </h1>

//         <p
//           style={{
//             color: "#55FF60",
//             fontSize: isMobile ? "16px" : "20px",
//             marginTop: "22px",
//             lineHeight: 1.6,
//             minHeight: "32px",
//           }}
//         >
//           {typedText}
//         </p>

//         <div
//           style={{
//             display: "flex",
//             gap: "18px",
//             marginTop: "35px",
//             flexWrap: "wrap",
//           }}
//         >
//           <button
//             style={{
//               padding: "16px 34px",
//               borderRadius: "999px",
//               border: "none",
//               background: "#55FF60",
//               color: "#000",
//               fontWeight: 700,
//               cursor: "pointer",
//             }}
//           >
//             Get Started
//           </button>

//           <button
//             style={{
//               padding: "16px 34px",
//               borderRadius: "999px",
//               border: "1px solid rgba(255,255,255,0.15)",
//               background: "rgba(255,255,255,0.06)",
//               color: "#fff",
//               fontWeight: 600,
//               cursor: "pointer",
//             }}
//           >
//             Watch Demo
//           </button>
//         </div>

//         <div
//           style={{
//             display: "flex",
//             gap: isMobile ? "24px" : "42px",
//             marginTop: "55px",
//             flexWrap: "wrap",
//           }}
//         >
//           {[
//             ["500+", "Companies"],
//             ["98%", "Automation"],
//             ["24/7", "AI Support"],
//             ["50+", "Employees"],
//           ].map((item, index) => (
//             <div key={index}>
//               <h3
//                 style={{
//                   color: "#55FF60",
//                   fontSize: isMobile ? "22px" : "30px",
//                 }}
//               >
//                 {item[0]}
//               </h3>

//               <p
//                 style={{
//                   color: "rgba(255,255,255,0.65)",
//                   fontSize: "14px",
//                 }}
//               >
//                 {item[1]}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SplineRobot;
















// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for AI automation",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const [scrollY, setScrollY] = useState(0);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;

//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();

//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);

//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     let ticking = false;

//     const handleScroll = () => {
//       if (!ticking) {
//         window.requestAnimationFrame(() => {
//           setScrollY(window.scrollY);
//           ticking = false;
//         });

//         ticking = true;
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const scrollSpeed = scrollY * 0.35;

//   const contentTranslate = scrollSpeed;
//   const splineTranslate = scrollSpeed;
//   const splineScale = Math.max((isMobile ? 0.95 : 1.05) - scrollY / 4000, 0.85);
//   const splineOpacity = Math.max(1 - scrollY / 700, 0);
//   const glowTranslate = scrollY * 0.18;
//   const fadeOut = Math.max(1 - scrollY / 700, 0);

//   return (
//     <section
//       style={{
//         width: "100%",
//         minHeight: "100vh",
//         background: "#000",
//         overflow: "hidden",
//         position: "relative",
//       }}
//     >
//       {/* Glow */}
//       <div
//         style={{
//           position: "absolute",
//           width: isMobile ? "220px" : "420px",
//           height: isMobile ? "220px" : "420px",
//           background: "#55FF60",
//           borderRadius: "50%",
//           filter: "blur(140px)",
//           opacity: 0.1,
//           right: "10%",
//           top: "15%",
//           zIndex: 0,
//           pointerEvents: "none",
//           transform: `translateY(${glowTranslate}px)`,
//           transition: "transform 0.08s linear",
//           willChange: "transform",
//         }}
//       />

//       {/* Spline */}
//       <div
//         style={{
//           position: "absolute",
//           right: isMobile ? "-80%" : "-18%",
//           top: isMobile ? "20%" : "-8%",
//           width: isMobile ? "170%" : "95%",
//           height: "100%",
//           zIndex: 1,
//           pointerEvents: "none",
//           transform: `translateY(-${splineTranslate}px) scale(${splineScale})`,
//           opacity: splineOpacity,
//           transition: "transform 0.08s linear, opacity 0.08s linear",
//           willChange: "transform, opacity",
//         }}
//       >
//         <spline-viewer
//           loading-anim-type="none"
//           url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//           style={{
//             width: "120%",
//             height: "150%",
//           }}
//         />
//       </div>

//       {/* Overlay */}
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: isMobile ? "100%" : "55%",
//           background: isMobile
//             ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//             : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//           zIndex: 5,
//           pointerEvents: "none",
//         }}
//       />

//       {/* Logo */}
//       <div
//         style={{
//           position: "absolute",
//           top: isMobile ? "12px" : "20px",
//           left: isMobile ? "12px" : "45px",
//           zIndex: 20,
//           opacity: fadeOut,
//           transform: `translateY(-${contentTranslate * 0.2}px)`,
//           transition: "transform 0.08s linear, opacity 0.08s linear",
//         }}
//       >
//         <img
//           src={logo}
//           alt="Logo"
//           style={{
//             width: isMobile ? "110px" : "170px",
//             height: "auto",
//             objectFit: "contain",
//           }}
//         />
//       </div>

//       {/* Content */}
//       <div
//         style={{
//           position: "relative",
//           zIndex: 10,
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: isMobile ? "flex-end" : "center",
//           paddingLeft: isMobile ? "22px" : "5vw",
//           paddingRight: "20px",
//           paddingBottom: isMobile ? "100px" : "0",
//           maxWidth: "700px",
//           transform: `translateY(-${contentTranslate}px)`,
//           opacity: fadeOut,
//           transition: "transform 0.08s linear, opacity 0.08s linear",
//           willChange: "transform, opacity",
//         }}
//       >
//         <h1 style={{
//           color: "#fff",
//           fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//           lineHeight: 1,
//           fontWeight: 800,
//           letterSpacing: "-2px",
//         }}>
//           Human <br />
//           <span style={{
//             background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//           }}>
//             Capital
//           </span>
//           <br />
//           Management
//         </h1>

//         <p style={{
//           color: "#55FF60",
//           fontSize: isMobile ? "16px" : "20px",
//           marginTop: "22px",
//           lineHeight: 1.6,
//           minHeight: "32px",
//         }}>
//           {typedText}
//         </p>

//         <div style={{
//           display: "flex",
//           gap: "18px",
//           marginTop: "35px",
//           flexWrap: "wrap",
//         }}>
//           <button style={{
//             padding: "16px 34px",
//             borderRadius: "999px",
//             border: "none",
//             background: "#55FF60",
//             color: "#000",
//             fontWeight: 700,
//             cursor: "pointer",
//           }}>
//             Get Started
//           </button>

//           <button style={{
//             padding: "16px 34px",
//             borderRadius: "999px",
//             border: "1px solid rgba(255,255,255,0.15)",
//             background: "rgba(255,255,255,0.06)",
//             color: "#fff",
//             fontWeight: 600,
//             cursor: "pointer",
//           }}>
//             Watch Demo
//           </button>
//         </div>

//         <div style={{
//           display: "flex",
//           gap: isMobile ? "24px" : "42px",
//           marginTop: "55px",
//           flexWrap: "wrap",
//         }}>
//           {[
//             ["500+", "Companies"],
//             ["98%", "Automation"],
//             ["24/7", "AI Support"],
//             ["50+", "Employees"],
//           ].map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 transform: `translateY(-${contentTranslate}px)`,
//                 opacity: fadeOut,
//                 transition: "transform 0.08s linear, opacity 0.08s linear",
//               }}
//             >
//               <h3 style={{
//                 color: "#55FF60",
//                 fontSize: isMobile ? "22px" : "30px",
//               }}>
//                 {item[0]}
//               </h3>

//               <p style={{
//                 color: "rgba(255,255,255,0.65)",
//                 fontSize: "14px",
//               }}>
//                 {item[1]}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SplineRobot;













// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   // "Built for AI automation",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const [scrollY, setScrollY] = useState(0);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;

//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();

//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);

//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     let ticking = false;

//     const handleScroll = () => {
//       if (!ticking) {
//         window.requestAnimationFrame(() => {
//           setScrollY(window.scrollY);
//           ticking = false;
//         });

//         ticking = true;
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const progress = Math.min(scrollY / window.innerHeight, 1);

//   const heroScale = 1 - progress * 0.18;
//   const heroOpacity = 1 - progress * 0.9;
//   const heroBlur = progress * 6;

//   const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   const glowTranslate = scrollY * 0.12;

//   return (

//      <> <Navbar />

//     <section
//       style={{
//         width: "100%",
//         height: "100vh",
//         background: "#000",
//         position: "relative",
//       }}
//     >
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           width: "100%",
//           height: "100vh",
//           overflow: "hidden",
//           transform: `scale(${heroScale})`,
//           opacity: heroOpacity,
//           filter: `blur(${heroBlur}px)`,
//           transition: "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
//           willChange: "transform, opacity, filter",
//           background: "#000",
//         }}
//       >
//         {/* Glow */}
//         <div
//           style={{
//             position: "absolute",
//             width: isMobile ? "220px" : "420px",
//             height: isMobile ? "220px" : "420px",
//             background: "#55FF60",
//             borderRadius: "50%",
//             filter: "blur(140px)",
//             opacity: 0.1,
//             right: "10%",
//             top: "15%",
//             zIndex: 0,
//             pointerEvents: "none",
//             transform: `translateY(${glowTranslate}px)`,
//             transition: "transform 0.08s linear",
//             willChange: "transform",
//           }}
//         />

//         {/* Spline */}
//         <div
//           style={{
//             position: "absolute",
//             right: isMobile ? "-80%" : "-18%",
//             top: isMobile ? "20%" : "-8%",
//             width: isMobile ? "170%" : "95%",
//             height: "100%",
//             zIndex: 1,
//             pointerEvents: "none",
//             transform: `scale(${splineScale})`,
//             transition: "transform 0.08s linear",
//             willChange: "transform",
//           }}
//         >
//           <spline-viewer
//             loading-anim-type="none"
//             url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//             style={{
//               width: "120%",
//               height: "150%",
//             }}
//           />
//         </div>

//         {/* Overlay */}
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             width: isMobile ? "100%" : "55%",
//             background: isMobile
//               ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//               : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//             zIndex: 5,
//             pointerEvents: "none",
//           }}
//         />

//         {/* Logo */}
//         <div
//           style={{
//             position: "absolute",
//             top: isMobile ? "12px" : "20px",
//             left: isMobile ? "12px" : "45px",
//             zIndex: 20,
//           }}
//         >
//           <img
//             src={logo}
//             alt="Logo"
//             style={{
//               width: isMobile ? "110px" : "170px",
//               height: "auto",
//               objectFit: "contain",
//             }}
//           />
//         </div>

//         {/* Content */}
//         <div
//           style={{
//             position: "relative",
//             zIndex: 10,
//             minHeight: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: isMobile ? "flex-end" : "center",
//             paddingLeft: isMobile ? "22px" : "5vw",
//             paddingRight: "20px",
//             paddingBottom: isMobile ? "100px" : "0",
//             maxWidth: "700px",
//           }}
//         >
//           <h1
//             style={{
//               color: "#fff",
//               fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//               lineHeight: 1,
//               fontWeight: 800,
//               letterSpacing: "-2px",
//             }}
//           >
//             Human <br />
//             <span
//               style={{
//                 background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               Capital
//             </span>
//             <br />
//             Management
//           </h1>

//           <p
//             style={{
//               color: "#55FF60",
//               fontSize: isMobile ? "16px" : "20px",
//               marginTop: "22px",
//               lineHeight: 1.6,
//               minHeight: "32px",
//             }}
//           >
//             {typedText}
//           </p>

//           <div
//             style={{
//               display: "flex",
//               gap: "18px",
//               marginTop: "35px",
//               flexWrap: "wrap",
//             }}
//           >
//             <button
//               style={{
//                 padding: "16px 34px",
//                 borderRadius: "999px",
//                 border: "none",
//                 background: "#55FF60",
//                 color: "#000",
//                 fontWeight: 700,
//                 cursor: "pointer",
//               }}
//             >
//               Get Started
//             </button>

//             <button
//               style={{
//                 padding: "16px 34px",
//                 borderRadius: "999px",
//                 border: "1px solid rgba(255,255,255,0.15)",
//                 background: "rgba(255,255,255,0.06)",
//                 color: "#fff",
//                 fontWeight: 600,
//                 cursor: "pointer",
//               }}
//             >
//               Watch Demo
//             </button>
//           </div>

//           <div
//             style={{
//               display: "flex",
//               gap: isMobile ? "24px" : "42px",
//               marginTop: "55px",
//               flexWrap: "wrap",
//             }}
//           >
//             {[
//               // ["500+", "Companies"],
//               ["98%", "Automation"],
//               ["24/7", "Support"],
//               ["50+", "Employees"],
//             ].map((item, index) => (
//               <div key={index}>
//                 <h3
//                   style={{
//                     color: "#55FF60",
//                     fontSize: isMobile ? "22px" : "30px",
//                   }}
//                 >
//                   {item[0]}
//                 </h3>

//                 <p
//                   style={{
//                     color: "rgba(255,255,255,0.65)",
//                     fontSize: "14px",
//                   }}
//                 >
//                   {item[1]}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//      </>
//   );
// };

// export default SplineRobot;



















// working with lightning chip

// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     let ticking = false;

//     const handleScroll = () => {
//       if (!ticking) {
//         window.requestAnimationFrame(() => {
//           setScrollY(window.scrollY);
//           ticking = false;
//         });
//         ticking = true;
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const progress = Math.min(scrollY / window.innerHeight, 1);

//   const heroScale = 1 - progress * 0.18;
//   const heroOpacity = 1 - progress * 0.9;
//   const heroBlur = progress * 6;

//   const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <section
//         style={{
//           width: "100%",
//           height: "100vh",
//           background: "#000",
//           position: "relative",
//         }}
//       >
//         <div
//           style={{
//             position: "sticky",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: `scale(${heroScale})`,
//             opacity: heroOpacity,
//             filter: `blur(${heroBlur}px)`,
//             transition:
//               "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
//             willChange: "transform, opacity, filter",
//             background: "#000",
//           }}
//         >
//           {/* Glow */}
//           <div
//             style={{
//               position: "absolute",
//               width: isMobile ? "220px" : "420px",
//               height: isMobile ? "220px" : "420px",
//               background: "#55FF60",
//               borderRadius: "50%",
//               filter: "blur(140px)",
//               opacity: 0.1,
//               right: "10%",
//               top: "15%",
//               zIndex: 0,
//               pointerEvents: "none",
//               transform: `translateY(${glowTranslate}px)`,
//               transition: "transform 0.08s linear",
//             }}
//           />

//           {/* Spline */}
//           <div
//             style={{
//               position: "absolute",
//               right: isMobile ? "-80%" : "-18%",
//               top: isMobile ? "20%" : "-8%",
//               width: isMobile ? "170%" : "95%",
//               height: "100%",
//               zIndex: 1,
//               pointerEvents: "none",
//               transform: `scale(${splineScale})`,
//               transition: "transform 0.08s linear",
//             }}
//           >
//             <spline-viewer
//               loading-anim-type="none"
//               url="https://prod.spline.design/RF8xxMOmf3SI1bb7/scene.splinecode"
//               style={{
//                 width: "120%",
//                 height: "150%",
//               }}
//             />
//           </div>

//           {/* Overlay */}
//           <div
//             style={{
//               position: "absolute",
//               inset: 0,
//               width: isMobile ? "100%" : "55%",
//               background: isMobile
//                 ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//                 : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//               zIndex: 5,
//               pointerEvents: "none",
//             }}
//           />

//           {/* Logo */}
//           <div
//             style={{
//               position: "absolute",
//               top: isMobile ? "12px" : "10px",
//               left: isMobile ? "12px" : "45px",
//               zIndex: 20,
//             }}
//           >
//             <img
//               src={logo}
//               alt="Logo"
//               style={{
//                 width: isMobile ? "110px" : "160px",
//                 height: "auto",
//               }}
//             />
//           </div>

//           {/* Content */}
//           <div
//             style={{
//               position: "relative",
//               zIndex: 10,
//               minHeight: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: isMobile ? "flex-end" : "center",
//               paddingLeft: isMobile ? "22px" : "5vw",
//               paddingRight: "20px",
//               paddingBottom: isMobile ? "100px" : "0",
//               maxWidth: "700px",
//             }}
//           >
//             <h1
//               style={{
//                 color: "#fff",
//                 fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//                 lineHeight: 1,
//                 fontWeight: 800,
//                 letterSpacing: "-2px",
//               }}
//             >
//               Human <br />
//               <span
//                 style={{
//                   background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Capital
//               </span>
//               <br />
//               Management
//             </h1>

//             <p
//               style={{
//                 color: "#55FF60",
//                 fontSize: isMobile ? "16px" : "20px",
//                 marginTop: "22px",
//                 lineHeight: 1.6,
//                 minHeight: "32px",
//               }}
//             >
//               {typedText}
//             </p>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "18px",
//                 marginTop: "35px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button

//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "none",
//                   background: "#55FF60",
//                   color: "#000",
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Get Started
//               </button>
//               <button
//                 onClick={() => setShowVideo(true)}
//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   background: "rgba(255,255,255,0.06)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   cursor: "pointer",
//                 }}
//               >
//                 Watch Demo
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: isMobile ? "24px" : "42px",
//                 marginTop: "55px",
//                 flexWrap: "wrap",
//               }}
//             >
//               {[
//                 ["98%", "Automation"],
//                 ["24/7", "Support"],
//                 ["50+", "Employees"],
//               ].map((item, index) => (
//                 <div key={index}>
//                   <h3
//                     style={{
//                       color: "#55FF60",
//                       fontSize: isMobile ? "22px" : "30px",
//                     }}
//                   >
//                     {item[0]}
//                   </h3>
//                   <p
//                     style={{
//                       color: "rgba(255,255,255,0.65)",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item[1]}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Video Modal */}
//         {showVideo && (
//           <div
//             onClick={() => setShowVideo(false)}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.85)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 9999,
//               padding: "20px",
//             }}
//           >
//             <div
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 width: "90%",
//                 maxWidth: "1000px",
//                 borderRadius: "20px",
//                 overflow: "hidden",
//                 boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
//               }}
//             >
//               <video
//                 src={demoVideo}
//                 controls
//                 autoPlay
//                 style={{
//                   width: "100%",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default SplineRobot;





















// working with world animation

// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <section
//         style={{
//           width: "100%",
//           height: "100vh",
//           background: "#000",
//           position: "relative",
//         }}
//       >
//         {/* <div
//           style={{
//             position: "sticky",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: `scale(${heroScale})`,
//             opacity: heroOpacity,
//             filter: `blur(${heroBlur}px)`, */}
//         <div
//           style={{
//             position: "sticky",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: "scale(1)",
//             opacity: 1,
//             filter: "none",
//             transition:
//               "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
//             willChange: "transform, opacity, filter",
//             background: "#000",
//           }}
//         >
//           {/* Glow */}

//           <div
//             style={{
//               position: "absolute",
//               width: isMobile ? "220px" : "420px",
//               height: isMobile ? "220px" : "420px",
//               background: "#55FF60",
//               borderRadius: "50%",
//               filter: "blur(140px)",
//               opacity: 0.1,
//               right: "10%",
//               top: "15%",
//               zIndex: 0,
//               pointerEvents: "none",
//               transform: "translateY(0)",
//             }}
//           />

//           {/* Spline */}
//           <div
//             style={{
//               position: "absolute",
//               right: isMobile ? "-80%" : "-18%",
//               top: isMobile ? "20%" : "-8%",
//               width: isMobile ? "170%" : "95%",
//               height: "100%",
//               zIndex: 1,
//               pointerEvents: "none",
//               transform: `scale(${isMobile ? 0.95 : 1.05})`,
//             }}
//           >
//             <spline-viewer
//               loading-anim-type="none"
//               url="https://prod.spline.design/8ehBgsrTY6319UoD/scene.splinecode"
//               style={{
//                 width: "120%",
//                 height: "150%",
//                 background: "transparent",
//               }}
//             />
//           </div>

//           {/* Overlay */}
//           <div
//             style={{
//               position: "absolute",
//               inset: 0,
//               width: isMobile ? "100%" : "55%",
//               background: isMobile
//                 ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//                 : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//               zIndex: 5,
//               pointerEvents: "none",
//             }}
//           />

//           {/* Logo */}
//           <div
//             style={{
//               position: "absolute",
//               top: isMobile ? "12px" : "10px",
//               left: isMobile ? "12px" : "45px",
//               zIndex: 20,
//             }}
//           >
//             <img
//               src={logo}
//               alt="Logo"
//               style={{
//                 width: isMobile ? "110px" : "160px",
//                 height: "auto",
//               }}
//             />
//           </div>

//           {/* Content */}
//           <div
//             style={{
//               position: "relative",
//               zIndex: 10,
//               minHeight: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: isMobile ? "flex-end" : "center",
//               paddingLeft: isMobile ? "22px" : "5vw",
//               paddingRight: "20px",
//               paddingBottom: isMobile ? "100px" : "0",
//               maxWidth: "700px",
//             }}
//           >
//             <h1
//               style={{
//                 color: "#fff",
//                 fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//                 lineHeight: 1,
//                 fontWeight: 800,
//                 letterSpacing: "-2px",
//               }}
//             >
//               Human <br />
//               <span
//                 style={{
//                   background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Capital
//               </span>
//               <br />
//               Management
//             </h1>

//             <p
//               style={{
//                 color: "#55FF60",
//                 fontSize: isMobile ? "16px" : "20px",
//                 marginTop: "22px",
//                 lineHeight: 1.6,
//                 minHeight: "32px",
//               }}
//             >
//               {typedText}
//             </p>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "18px",
//                 marginTop: "35px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button

//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "none",
//                   background: "#55FF60",
//                   color: "#000",
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Get Started
//               </button>
//               <button
//                 onClick={() => setShowVideo(true)}
//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   background: "rgba(255,255,255,0.06)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   cursor: "pointer",
//                 }}
//               >
//                 Watch Demo
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: isMobile ? "24px" : "42px",
//                 marginTop: "55px",
//                 flexWrap: "wrap",
//               }}
//             >
//               {[
//                 ["98%", "Automation"],
//                 ["24/7", "Support"],
//                 ["50+", "Employees"],
//               ].map((item, index) => (
//                 <div key={index}>
//                   <h3
//                     style={{
//                       color: "#55FF60",
//                       fontSize: isMobile ? "22px" : "30px",
//                     }}
//                   >
//                     {item[0]}
//                   </h3>
//                   <p
//                     style={{
//                       color: "rgba(255,255,255,0.65)",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item[1]}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Video Modal */}
//         {showVideo && (
//           <div
//             onClick={() => setShowVideo(false)}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.85)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 9999,
//               padding: "20px",
//             }}
//           >
//             <div
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 width: "90%",
//                 maxWidth: "1000px",
//                 borderRadius: "20px",
//                 overflow: "hidden",
//                 boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
//               }}
//             >
//               <video
//                 src={demoVideo}
//                 controls
//                 autoPlay
//                 style={{
//                   width: "100%",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default SplineRobot;



















// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";
// // import bgImage from "../../../assets/black-and-gold-vector.webp";
// // import bgImage from "../../../assets/bg-testing.jpg";
// import bgImage from "../../../assets/bg-test.webp";
// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//      <section
//   style={{
//     width: "100%",
//     height: "100vh",
//     position: "relative",
//     overflow: "hidden",
//     backgroundImage: `url(${bgImage})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//   }}
// >
//   <div
//     style={{
//       position: "absolute",
//       inset: 0,
//       background:
//         "linear-gradient(90deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.72) 45%, rgba(0,0,0,0.2) 100%)",
//       zIndex: 1,
//     }}
//   />

//   {/* Gold Glow */}
//   <div
//     style={{
//       position: "absolute",
//       width: isMobile ? "250px" : "500px",
//       height: isMobile ? "250px" : "500px",
//       background: "#D4AF37",
//       borderRadius: "50%",
//       filter: "blur(180px)",
//       opacity: 0.15,
//       top: "10%",
//       right: "-5%",
//       zIndex: 2,
//     }}
//   />

//   {/* Logo */}
//   <div
//     style={{
//       position: "absolute",
//       top: isMobile ? "15px" : "20px",
//       left: isMobile ? "15px" : "45px",
//       zIndex: 20,
//     }}
//   >
//     <img
//       src={logo}
//       alt="Logo"
//       style={{
//         width: isMobile ? "110px" : "160px",
//       }}
//     />
//   </div>

//   {/* Content */}
//   <div
//     style={{
//       position: "relative",
//       zIndex: 10,
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       paddingLeft: isMobile ? "25px" : "5vw",
//       paddingRight: "20px",
//       maxWidth: "750px",
//     }}
//   >
//     <h1
//       style={{
//         color: "#fff",
//         fontSize: isMobile ? "48px" : "clamp(50px, 6vw, 82px)",
//         lineHeight: 1,
//         fontWeight: 800,
//         letterSpacing: "-2px",
//       }}
//     >
//       Human <br />
//       <span
//         style={{
//           background: "linear-gradient(90deg,#D4AF37,#FFD700,#FFF3B0)",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//         }}
//       >
//         Capital
//       </span>
//       <br />
//       Management
//     </h1>

//     <p
//       style={{
//         color: "#D4AF37",
//         fontSize: isMobile ? "16px" : "22px",
//         marginTop: "22px",
//         minHeight: "34px",
//         fontWeight: "500",
//       }}
//     >
//       {typedText}
//     </p>

//     <div
//       style={{
//         display: "flex",
//         gap: "18px",
//         marginTop: "35px",
//         flexWrap: "wrap",
//       }}
//     >
//       <button
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "none",
//           background: "#D4AF37",
//           color: "#111",
//           fontWeight: 700,
//           cursor: "pointer",
//           boxShadow: "0 10px 35px rgba(212,175,55,0.4)",
//         }}
//       >
//         Get Started
//       </button>

//       <button
//         onClick={() => setShowVideo(true)}
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "1px solid rgba(212,175,55,0.3)",
//           background: "rgba(255,255,255,0.05)",
//           backdropFilter: "blur(10px)",
//           color: "#fff",
//           fontWeight: 600,
//           cursor: "pointer",
//         }}
//       >
//         Watch Demo
//       </button>
//     </div>

//     <div
//       style={{
//         display: "flex",
//         gap: isMobile ? "24px" : "50px",
//         marginTop: "60px",
//         flexWrap: "wrap",
//       }}
//     >
//       {[
//         ["98%", "Automation"],
//         ["24/7", "Support"],
//         ["50+", "Employees"],
//       ].map((item, index) => (
//         <div key={index}>
//           <h3
//             style={{
//               color: "#D4AF37",
//               fontSize: isMobile ? "24px" : "34px",
//               marginBottom: "5px",
//             }}
//           >
//             {item[0]}
//           </h3>

//           <p
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: "14px",
//             }}
//           >
//             {item[1]}
//           </p>
//         </div>
//       ))}
//     </div>
//   </div>
// </section>
//     </>
//   );
// };

// export default SplineRobot;














// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";
// // import bgImage from "../../../assets/black-and-gold-vector.webp";
// // import bgImage from "../../../assets/bg-testing.jpg";
// // import bgImage from "../../../assets/left.jpg";
// import bgImage from "../../../assets/xyz.jpg";
// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//     <section
//   style={{
//     width: "100%",
//     height: "100vh",
//     position: "relative",
//     overflow: "hidden",
//     backgroundImage: `url(${bgImage})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//   }}
// >
//   {/* Dark Overlay */}
//   <div
//     style={{
//       position: "absolute",
//       inset: 0,
//       background:
//         "linear-gradient(90deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.72) 45%, rgba(0,0,0,0.2) 100%)",
//       zIndex: 1,
//     }}
//   />

//   {/* Gold Glow */}
//   <div
//     style={{
//       position: "absolute",
//       width: isMobile ? "250px" : "500px",
//       height: isMobile ? "250px" : "500px",
//       background: "#D4AF37",
//       borderRadius: "50%",
//       filter: "blur(180px)",
//       opacity: 0.15,
//       top: "10%",
//       right: "-5%",
//       zIndex: 2,
//     }}
//   />

//   {/* Logo */}
//   <div
//     style={{
//       position: "absolute",
//       top: isMobile ? "15px" : "20px",
//       left: isMobile ? "15px" : "45px",
//       zIndex: 20,
//     }}
//   >
//     <img
//       src={logo}
//       alt="Logo"
//       style={{
//         width: isMobile ? "110px" : "160px",
//       }}
//     />
//   </div>

//   {/* Content */}
//   <div
//     style={{
//       position: "relative",
//       zIndex: 10,
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       paddingLeft: isMobile ? "25px" : "5vw",
//       paddingRight: "20px",
//       maxWidth: "700px",
//     }}
//   >
//     <h1
//       style={{
//         color: "#fff",
//         fontSize: isMobile ? "48px" : "clamp(50px, 6vw, 82px)",
//         lineHeight: 1,
//         fontWeight: 800,
//         letterSpacing: "-2px",
//         margin: 0,
//         marginTop:"100px"
//       }}
//     >
//       Human <br />

//       <span
//         style={{
//           background:
//             "linear-gradient(90deg,#D4AF37,#FFD700,#FFF3B0)",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//         }}
//       >
//         Capital
//       </span>

//       <br />
//       Management
//     </h1>

//     <p
//       style={{
//         color: "#D4AF37",
//         fontSize: isMobile ? "16px" : "22px",
//         marginTop: "22px",
//         minHeight: "34px",
//         fontWeight: "500",
//       }}
//     >
//       {typedText}
//     </p>

//     <div
//       style={{
//         display: "flex",
//         gap: "18px",
//         marginTop: "35px",
//         flexWrap: "wrap",
//       }}
//     >
//       <button
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "none",
//           background: "#D4AF37",
//           color: "#111",
//           fontWeight: 700,
//           cursor: "pointer",
//           boxShadow: "0 10px 35px rgba(212,175,55,0.4)",
//         }}
//       >
//         Get Started
//       </button>

//       <button
//         onClick={() => setShowVideo(true)}
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "1px solid rgba(212,175,55,0.3)",
//           background: "rgba(255,255,255,0.05)",
//           backdropFilter: "blur(10px)",
//           color: "#fff",
//           fontWeight: 600,
//           cursor: "pointer",
//         }}
//       >
//         Watch Demo
//       </button>
//     </div>

//     <div
//       style={{
//         display: "flex",
//         gap: isMobile ? "24px" : "50px",
//         marginTop: "60px",
//         flexWrap: "wrap",
//       }}
//     >
//       {[
//         ["98%", "Automation"],
//         ["24/7", "Support"],
//         ["50+", "Employees"],
//       ].map((item, index) => (
//         <div key={index}>
//           <h3
//             style={{
//               color: "#D4AF37",
//               fontSize: isMobile ? "24px" : "34px",
//               marginBottom: "5px",
//             }}
//           >
//             {item[0]}
//           </h3>

//           <p
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: "14px",
//             }}
//           >
//             {item[1]}
//           </p>
//         </div>
//       ))}
//     </div>
//   </div>
// </section>
//     </>
//   );
// };

// export default SplineRobot;



















// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";
// // import bgImage from "../../../assets/black-and-gold-vector.webp";
// // import bgImage from "../../../assets/bg-testing.jpg";
// // import bgImage from "../../../assets/left.jpg";
// // import bgImage from "../../../assets/xyz.jpg";
// import bgImage from "../../../assets/tttt.png";
// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//     <section
//   style={{
//     width: "100%",
//     height: "100vh",
//     position: "relative",
//     overflow: "hidden",
//     backgroundImage: `url(${bgImage})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//   }}
// >
//   {/* Dark Overlay */}
//   <div
//     style={{
//       position: "absolute",
//       inset: 0,
//       background:
//         "linear-gradient(90deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.72) 45%, rgba(0,0,0,0.2) 100%)",
//       zIndex: 1,
//     }}
//   />

//   {/* Gold Glow */}
//   <div
//     style={{
//       position: "absolute",
//       width: isMobile ? "250px" : "500px",
//       height: isMobile ? "250px" : "500px",
//       background: "#d43737",
//       borderRadius: "50%",
//       filter: "blur(180px)",
//       opacity: 0.15,
//       top: "10%",
//       right: "-5%",
//       zIndex: 2,
//     }}
//   />

//   {/* Logo */}
//   <div
//     style={{
//       position: "absolute",
//       top: isMobile ? "15px" : "20px",
//       left: isMobile ? "15px" : "45px",
//       zIndex: 20,
//     }}
//   >
//     <img
//       src={logo}
//       alt="Logo"
//       style={{
//         width: isMobile ? "110px" : "160px",
//       }}
//     />
//   </div>

//   {/* Content */}
//   <div
//     style={{
//       position: "relative",
//       zIndex: 10,
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       paddingLeft: isMobile ? "25px" : "5vw",
//       paddingRight: "20px",
//       maxWidth: "700px",
//     }}
//   >
//     <h1
//       style={{
//         color: "#fff",
//         fontSize: isMobile ? "48px" : "clamp(50px, 6vw, 82px)",
//         lineHeight: 1,
//         fontWeight: 800,
//         letterSpacing: "-2px",
//         margin: 0,
//         marginTop:"100px"
//       }}
//     >
//       Human <br />

//       <span
//         style={{
//           background:
//             "linear-gradient(90deg,#D4AF37,#FFD700,#FFF3B0)",
//           WebkitBackgroundClip: "text",
//           WebkitTextFillColor: "transparent",
//         }}
//       >
//         Capital
//       </span>

//       <br />
//       Management
//     </h1>

//     <p
//       style={{
//         color: "#D4AF37",
//         fontSize: isMobile ? "16px" : "22px",
//         marginTop: "22px",
//         minHeight: "34px",
//         fontWeight: "500",
//       }}
//     >
//       {typedText}
//     </p>

//     <div
//       style={{
//         display: "flex",
//         gap: "18px",
//         marginTop: "35px",
//         flexWrap: "wrap",
//       }}
//     >
//       <button
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "none",
//           background: "#D4AF37",
//           color: "#111",
//           fontWeight: 700,
//           cursor: "pointer",
//           boxShadow: "0 10px 35px rgba(212,175,55,0.4)",
//         }}
//       >
//         Get Started
//       </button>

//       <button
//         onClick={() => setShowVideo(true)}
//         style={{
//           padding: "16px 36px",
//           borderRadius: "999px",
//           border: "1px solid rgba(212,175,55,0.3)",
//           background: "rgba(255,255,255,0.05)",
//           backdropFilter: "blur(10px)",
//           color: "#fff",
//           fontWeight: 600,
//           cursor: "pointer",
//         }}
//       >
//         Watch Demo
//       </button>
//     </div>

//     <div
//       style={{
//         display: "flex",
//         gap: isMobile ? "24px" : "50px",
//         marginTop: "60px",
//         flexWrap: "wrap",
//       }}
//     >
//       {[
//         ["98%", "Automation"],
//         ["24/7", "Support"],
//         ["50+", "Employees"],
//       ].map((item, index) => (
//         <div key={index}>
//           <h3
//             style={{
//               color: "#D4AF37",
//               fontSize: isMobile ? "24px" : "34px",
//               marginBottom: "5px",
//             }}
//           >
//             {item[0]}
//           </h3>

//           <p
//             style={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: "14px",
//             }}
//           >
//             {item[1]}
//           </p>
//         </div>
//       ))}
//     </div>
//   </div>
// </section>
//     </>
//   );
// };

// export default SplineRobot;










// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <section
//         style={{
//           width: "100%",
//           height: "100vh",
//           background: "#000",
//           position: "relative",
//         }}
//       >
//         {/* <div
//           style={{
//             position: "sticky",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: `scale(${heroScale})`,
//             opacity: heroOpacity,
//             filter: `blur(${heroBlur}px)`, */}
//         <div
//           style={{
//            position: "relative",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: "scale(1)",
//             opacity: 1,
//             filter: "none",
//             transition:
//               "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
//             willChange: "transform, opacity, filter",
//             background: "#000",
//           }}
//         >
//           {/* Glow */}

//           <div
//             style={{
//               position: "absolute",
//               width: isMobile ? "220px" : "420px",
//               height: isMobile ? "220px" : "420px",
//               background: "#55FF60",
//               borderRadius: "50%",
//               filter: "blur(140px)",
//               opacity: 0.1,
//               right: "10%",
//               top: "15%",
//               zIndex: 0,
//               pointerEvents: "none",
//               transform: "translateY(0)",
//             }}
//           />

//           {/* Spline */}
//           <div
//             style={{
//               position: "absolute",
//               right: isMobile ? "-80%" : "-18%",
//               top: isMobile ? "20%" : "-8%",
//               width: isMobile ? "170%" : "95%",
//               height: "100%",
//               zIndex: 1,
//               pointerEvents: "none",
//               transform: `scale(${isMobile ? 0.95 : 1.05})`,
//             }}
//           >
//             <spline-viewer
//   loading-anim-type="none"
//   url="https://prod.spline.design/8ehBgsrTY6319UoD/scene.splinecode"
//   style={{
//     width: "100%",
//     height: "100%",
//     background: "transparent",
//   }}
// />
//           </div>

//           {/* Overlay */}
//           <div
//             style={{
//               position: "absolute",
//               inset: 0,
//               width: isMobile ? "100%" : "55%",
//               background: isMobile
//                 ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//                 : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//               zIndex: 5,
//               pointerEvents: "none",
//             }}
//           />

//           {/* Logo */}
//           <div
//             style={{
//               position: "absolute",
//               top: isMobile ? "12px" : "10px",
//               left: isMobile ? "12px" : "45px",
//               zIndex: 20,
//             }}
//           >
//             {/* <img
//               src={logo}
//               alt="Logo"
//               style={{
//                 width: isMobile ? "110px" : "160px",
//                 height: "auto",
//               }}
//             /> */}
//           </div>

//           {/* Content */}
//           <div
//             style={{
//               position: "relative",
//               zIndex: 10,
//               minHeight: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: isMobile ? "flex-end" : "center",
//               paddingLeft: isMobile ? "22px" : "5vw",
//               paddingRight: "20px",
//               paddingBottom: isMobile ? "100px" : "0",
//               maxWidth: "700px",
//             }}
//           >
//             <h1
//               style={{
//                 color: "#fff",
//                 fontSize: isMobile ? "48px" : "clamp(42px, 6vw, 78px)",
//                 lineHeight: 1,
//                 fontWeight: 800,
//                 letterSpacing: "-2px",
//               }}
//             >
//               Human <br />
//               <span
//                 style={{
//                   background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Capital
//               </span>
//               <br />
//               Management
//             </h1>

//             <p
//               style={{
//                 color: "#55FF60",
//                 fontSize: isMobile ? "16px" : "20px",
//                 marginTop: "22px",
//                 lineHeight: 1.6,
//                 minHeight: "32px",
//               }}
//             >
//               {typedText}
//             </p>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "18px",
//                 marginTop: "35px",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button

//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "none",
//                   background: "#55FF60",
//                   color: "#000",
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Get Started
//               </button>
//               <button
//                 onClick={() => setShowVideo(true)}
//                 style={{
//                   padding: "16px 34px",
//                   borderRadius: "999px",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   background: "rgba(255,255,255,0.06)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   cursor: "pointer",
//                 }}
//               >
//                 Watch Demo
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 gap: isMobile ? "24px" : "42px",
//                 marginTop: "55px",
//                 flexWrap: "wrap",
//               }}
//             >
//               {[
//                 ["98%", "Automation"],
//                 ["24/7", "Support"],
//                 ["50+", "Employees"],
//               ].map((item, index) => (
//                 <div key={index}>
//                   <h3
//                     style={{
//                       color: "#55FF60",
//                       fontSize: isMobile ? "22px" : "30px",
//                     }}
//                   >
//                     {item[0]}
//                   </h3>
//                   <p
//                     style={{
//                       color: "rgba(255,255,255,0.65)",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item[1]}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Video Modal */}
//         {showVideo && (
//           <div
//             onClick={() => setShowVideo(false)}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.85)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 9999,
//               padding: "20px",
//             }}
//           >
//             <div
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 width: "90%",
//                 maxWidth: "1000px",
//                 borderRadius: "20px",
//                 overflow: "hidden",
//                 boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
//               }}
//             >
//               <video
//                 src={demoVideo}
//                 controls
//                 autoPlay
//                 style={{
//                   width: "100%",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default SplineRobot;





















// import React, { useEffect, useState, useMemo } from "react";
// import logo from "../../../assets/logo-white-r.png";
// import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";

// const phrases = [
//   "Built for modern HR",
//   "Built for enterprises",
//   "Built for scalable teams",
// ];

// const SplineRobot = () => {
//   const [typedText, setTypedText] = useState("");
//   const [phraseIndex, setPhraseIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//   // const [scrollY, setScrollY] = useState(0);
//   const [showVideo, setShowVideo] = useState(false);

//   const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);
//   const isSmallMobile = screenWidth < 480;

//   useEffect(() => {
//     let timeout;
//     const currentPhrase = phrases[phraseIndex];
//     let char = 0;

//     const typeText = () => {
//       if (char <= currentPhrase.length) {
//         setTypedText(currentPhrase.slice(0, char));
//         char++;
//         timeout = setTimeout(typeText, 90);
//       } else {
//         timeout = setTimeout(() => {
//           setPhraseIndex((prev) => (prev + 1) % phrases.length);
//         }, 1800);
//       }
//     };

//     typeText();
//     return () => clearTimeout(timeout);
//   }, [phraseIndex]);

//   useEffect(() => {
//     let resizeTimer;

//     const handleResize = () => {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(() => {
//         setScreenWidth(window.innerWidth);
//       }, 150);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       clearTimeout(resizeTimer);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   // useEffect(() => {
//   //   let ticking = false;

//   //   const handleScroll = () => {
//   //     if (!ticking) {
//   //       window.requestAnimationFrame(() => {
//   //         setScrollY(window.scrollY);
//   //         ticking = false;
//   //       });
//   //       ticking = true;
//   //     }
//   //   };

//   //   window.addEventListener("scroll", handleScroll, { passive: true });
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   // const progress = Math.min(scrollY / window.innerHeight, 1);

//   // const heroScale = 1 - progress * 0.18;
//   // const heroOpacity = 1 - progress * 0.9;
//   // const heroBlur = progress * 6;

//   // const splineScale = (isMobile ? 0.95 : 1.05) - progress * 0.12;
//   // const glowTranslate = scrollY * 0.12;

//   const scrollToFeatures = () => {
//     const featuresSection = document.getElementById("features-section");

//     if (featuresSection) {
//       featuresSection.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   return (
//     <>
//       <Navbar />

//       <section
//         style={{
//           width: "100%",
//           height: "100vh",
//           background: "#000",
//           position: "relative",
//         }}
//       >
//         {/* <div
//           style={{
//             position: "sticky",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: `scale(${heroScale})`,
//             opacity: heroOpacity,
//             filter: `blur(${heroBlur}px)`, */}
//         <div
//           style={{
//             position: "relative",
//             top: 0,
//             width: "100%",
//             height: "100vh",
//             overflow: "hidden",
//             transform: "scale(1)",
//             opacity: 1,
//             filter: "none",
//             transition:
//               "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
//             willChange: "transform, opacity, filter",
//             background: "#000",
//           }}
//         >
//           {/* Glow */}

//           <div
//             style={{
//               position: "absolute",
//               width: isMobile ? "220px" : "420px",
//               height: isMobile ? "220px" : "420px",
//               background: "#55FF60",
//               borderRadius: "50%",
//               filter: "blur(140px)",
//               opacity: 0.1,
//               right: "10%",
//               top: "15%",
//               zIndex: 0,
//               pointerEvents: "none",
//               transform: "translateY(0)",
//             }}
//           />

//           {/* Spline */}
//           <div
//             style={{
//               position: "absolute",
//               right: isMobile ? "-120%" : "-18%",
//               top: isMobile ? "5%" : "-8%",
//               width: isMobile ? "220%" : "95%",
//               height: "100%",
//               zIndex: 1,
//               pointerEvents: "none",
//               transform: `scale(${isMobile ? 0.95 : 1.05})`,
//             }}
//           >
//             <spline-viewer
//               loading-anim-type="none"
//               url="https://prod.spline.design/8ehBgsrTY6319UoD/scene.splinecode"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 background: "transparent",
//               }}
//             />
//           </div>

//           {/* Overlay */}
//           <div
//             style={{
//               position: "absolute",
//               inset: 0,
//               width: isMobile ? "100%" : "55%",
//               background: isMobile
//                 ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
//                 : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
//               zIndex: 5,
//               pointerEvents: "none",
//             }}
//           />

//           {/* Logo */}
//           <div
//             style={{
//               position: "absolute",
//               top: isMobile ? "12px" : "10px",
//               left: isMobile ? "12px" : "45px",
//               zIndex: 20,
//             }}
//           >
//             {/* <img
//               src={logo}
//               alt="Logo"
//               style={{
//                 width: isMobile ? "110px" : "160px",
//                 height: "auto",
//               }}
//             /> */}
//           </div>

//           {/* Content */}
//           <div
//             style={{
//               position: "relative",
//               zIndex: 10,
//               minHeight: "100vh",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: isMobile ? "center" : "flex-start",
//               textAlign: isMobile ? "center" : "left",
//               paddingLeft: isMobile ? "20px" : "5vw",
//               paddingRight: isMobile ? "20px" : "20px",
//               paddingTop: isMobile ? "120px" : "0",
//               paddingBottom: isMobile ? "50px" : "0",
//               maxWidth: isMobile ? "100%" : "700px",
//             }}
//           >
//             {/* <h1
//               style={{
//                 color: "#fff",
//                 fontSize: isSmallMobile
//                   ? "30px"
//                   : isMobile
//                     ? "36px"
//                     : "clamp(42px, 6vw, 78px)",
//                 maxWidth: isMobile ? "320px" : "100%",
//                 margin: isMobile ? "0 auto" : "0",
//                 lineHeight: 1,
//                 fontWeight: 800,
//                 letterSpacing: "-2px",
//               }}
//             >
//               Human <br />
//               <span
//                 style={{
//                   background: "linear-gradient(90deg, #55FF60, #00ffcc)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 Capital
//               </span>
//               <br />
//               Management
//             </h1> */}

//             <h1
//               style={{
//                 fontSize: isSmallMobile
//                   ? "42px"
//                   : isMobile
//                     ? "56px"
//                     : "clamp(72px, 8vw, 110px)",
//                 lineHeight: 1,
//                 fontWeight: 900,
//                 letterSpacing: "-2px",
//                 marginBottom: "12px",
//                 background: "linear-gradient(90deg, #39ff4d 0%, #55FF60 40%, #7DFF85 100%)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               GTELINQ
//             </h1>

//             <p
//               style={{
//                 fontSize: isMobile ? "18px" : "28px",
//                 fontWeight: 600,
//                 color: "#e8e8e8",
//                 marginBottom: "16px",
//               }}
//             >
//               Artificially Intelligent Workforce Management System
//             </p>



//             <p
//               style={{
//                 color: "#55FF60",
//                 fontSize: isMobile ? "14px" : "20px",
//                 textAlign: isMobile ? "center" : "left",
//                 marginTop: "22px",
//                 lineHeight: 1.6,
//                 minHeight: "32px",
//               }}
//             >
//               {typedText}
//             </p>

//             <div
//               style={{
//                 display: "flex",
//                 gap: "12px",
//                 marginTop: "30px",
//                 flexDirection: isMobile ? "column" : "row",
//                 width: isMobile ? "100%" : "auto",
//                 maxWidth: isMobile ? "320px" : "none",
//               }}
//             >
//               <button

//                 style={{
//                   padding: isMobile ? "14px" : "16px 34px",
//                   width: isMobile ? "100%" : "auto",
//                   borderRadius: "999px",
//                   border: "none",
//                   background: "#55FF60",
//                   color: "#000",
//                   fontWeight: 700,
//                   cursor: "pointer",
//                 }}
//               >
//                 Get Started
//               </button>
//               <button
//                 onClick={() => setShowVideo(true)}
//                 style={{
//                   padding: isMobile ? "14px" : "16px 34px",
//                   width: isMobile ? "100%" : "auto",
//                   borderRadius: "999px",
//                   border: "1px solid rgba(255,255,255,0.15)",
//                   background: "rgba(255,255,255,0.06)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   cursor: "pointer",
//                 }}
//               >
//                 Watch Demo
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: isMobile ? "space-between" : "flex-start",
//                 gap: isMobile ? "10px" : "42px",
//                 marginTop: "45px",
//                 width: isMobile ? "100%" : "auto",
//                 maxWidth: isMobile ? "320px" : "none",
//               }}
//             >
//               {[
//                 ["98%", "Automation"],
//                 ["24/7", "Support"],
//                 ["10+", "HR Modules"]

//               ].map((item, index) => (
//                 <div key={index}>
//                   <h3
//                     style={{
//                       color: "#55FF60",
//                       fontSize: isMobile ? "18px" : "30px",
//                     }}
//                   >
//                     {item[0]}
//                   </h3>
//                   <p
//                     style={{
//                       color: "rgba(255,255,255,0.65)",
//                       fontSize: "14px",
//                     }}
//                   >
//                     {item[1]}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Video Modal */}
//         {showVideo && (
//           <div
//             onClick={() => setShowVideo(false)}
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.85)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               zIndex: 9999,
//               padding: "20px",
//             }}
//           >
//             <div
//               onClick={(e) => e.stopPropagation()}
//               style={{
//                 width: isMobile ? "100%" : "90%",
//                 maxWidth: "1000px",
//                 borderRadius: isMobile ? "12px" : "20px",
//                 overflow: "hidden",
//                 boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
//               }}
//             >
//               <video
//                 src={demoVideo}
//                 controls
//                 autoPlay
//                 style={{
//                   width: "100%",
//                   display: "block",
//                 }}
//               />
//             </div>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default SplineRobot;

















import React, { useEffect, useState, useMemo } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo-white-r.png";
import Navbar from "../Navbar";
// import demoVideo from "../../../assets/attendance-management-demo.mp4";

const phrases = [
  "Built for modern HR",
  "Built for enterprises",
  "Built for scalable teams",
];

const SplineRobot = () => {
  const [typedText, setTypedText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  // const [scrollY, setScrollY] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate();

  const isMobile = useMemo(() => screenWidth < 768, [screenWidth]);
  const isSmallMobile = screenWidth < 480;

  useEffect(() => {
    let timeout;
    const currentPhrase = phrases[phraseIndex];
    let char = 0;

    const typeText = () => {
      if (char <= currentPhrase.length) {
        setTypedText(currentPhrase.slice(0, char));
        char++;
        timeout = setTimeout(typeText, 90);
      } else {
        timeout = setTimeout(() => {
          setPhraseIndex((prev) => (prev + 1) % phrases.length);
        }, 1800);
      }
    };

    typeText();
    return () => clearTimeout(timeout);
  }, [phraseIndex]);

  useEffect(() => {
    let resizeTimer;

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setScreenWidth(window.innerWidth);
      }, 150);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const scrollToFeatures = () => {
    const featuresSection = document.getElementById("features-section");

    if (featuresSection) {
      featuresSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const youtubeEmbedUrl =
    "https://www.youtube.com/embed/cu4SwU5JeAA?autoplay=1&rel=0";

  return (
    <>
      <Navbar />

      <section
        style={{
          width: "100%",
          height: "100vh",
          background: "#000",
          position: "relative",
        }}
      >
        {/* <div
          style={{
            position: "sticky",
            top: 0,
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            transform: `scale(${heroScale})`,
            opacity: heroOpacity,
            filter: `blur(${heroBlur}px)`, */}
        <div
          style={{
            position: "relative",
            top: 0,
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            transform: "scale(1)",
            opacity: 1,
            filter: "none",
            transition:
              "transform 0.08s linear, opacity 0.08s linear, filter 0.08s linear",
            willChange: "transform, opacity, filter",
            background: "#000",
          }}
        >
          {/* Glow */}

          <div
            style={{
              position: "absolute",
              width: isMobile ? "220px" : "420px",
              height: isMobile ? "220px" : "420px",
              background: "#55FF60",
              borderRadius: "50%",
              filter: "blur(140px)",
              opacity: 0.1,
              right: "10%",
              top: "15%",
              zIndex: 0,
              pointerEvents: "none",
              transform: "translateY(0)",
            }}
          />

          {/* Spline */}
          <div
            style={{
              position: "absolute",
              right: isMobile ? "0%" : "-18%",
              top: isMobile ? "5%" : "-8%",
              width: isMobile ? "140%" : "95%",
              height: "100%",
              zIndex: 1,
              pointerEvents: "none",
              transform: `scale(${isMobile ? 0.95 : 1.05})`,
            }}
          >
            <spline-viewer
              loading-anim-type="none"
              url="https://prod.spline.design/8ehBgsrTY6319UoD/scene.splinecode"
              style={{
                width: "100%",
                height: "100%",
                background: "transparent",
              }}
            />
          </div>

          {/* Overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              width: isMobile ? "100%" : "55%",
              background: isMobile
                ? "linear-gradient(to bottom, rgba(0,0,0,0.95), rgba(0,0,0,0.55), transparent)"
                : "linear-gradient(to right, rgba(0,0,0,0.94), rgba(0,0,0,0.55), transparent)",
              zIndex: 5,
              pointerEvents: "none",
            }}
          />

          {/* Logo */}
          <div
            style={{
              position: "absolute",
              top: isMobile ? "12px" : "10px",
              left: isMobile ? "12px" : "45px",
              zIndex: 20,
            }}
          >
            {/* <img
              src={logo}
              alt="Logo"
              style={{
                width: isMobile ? "110px" : "160px",
                height: "auto",
              }}
            /> */}
          </div>

          {/* Content */}
          <div
            style={{
              position: "relative",
              zIndex: 10,
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: isMobile ? "center" : "flex-start",
              textAlign: isMobile ? "center" : "left",
              paddingLeft: isMobile ? "20px" : "5vw",
              paddingRight: isMobile ? "20px" : "20px",
              paddingTop: isMobile ? "120px" : "0",
              paddingBottom: isMobile ? "50px" : "0",
              maxWidth: isMobile ? "100%" : "700px",
            }}
          >


            <h1
              style={{
                fontSize: isSmallMobile
                  ? "42px"
                  : isMobile
                    ? "56px"
                    : "clamp(72px, 8vw, 110px)",
                lineHeight: 1,
                fontWeight: 900,
                letterSpacing: "-2px",
                marginBottom: "12px",
                background: "linear-gradient(90deg, #39ff4d 0%, #55FF60 40%, #7DFF85 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              GTELINQ
            </h1>

            <p
              style={{
                fontSize: isMobile ? "18px" : "28px",
                fontWeight: 600,
                color: "#e8e8e8",
                marginBottom: "16px",
              }}
            >
              Artificially Intelligent Workforce Management System
            </p>



            <p
              style={{
                color: "#55FF60",
                fontSize: isMobile ? "14px" : "20px",
                textAlign: isMobile ? "center" : "left",
                marginTop: "22px",
                lineHeight: 1.6,
                minHeight: "32px",
              }}
            >
              {typedText}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                marginTop: "30px",
                flexDirection: isMobile ? "column" : "row",
                width: isMobile ? "100%" : "auto",
                maxWidth: isMobile ? "320px" : "none",
              }}
            >
              <button
                onClick={() => navigate("/pricing")}
                style={{
                  padding: isMobile ? "14px" : "16px 34px",
                  width: isMobile ? "100%" : "auto",
                  borderRadius: "999px",
                  border: "none",
                  background: "#55FF60",
                  color: "#000",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Get Started
              </button>
              <button
                onClick={() => setShowVideo(true)}
                style={{
                  padding: isMobile ? "14px" : "16px 34px",
                  width: isMobile ? "100%" : "auto",
                  borderRadius: "999px",
                  border: "1px solid rgba(255,255,255,0.15)",
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Watch Demo
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "space-between" : "flex-start",
                gap: isMobile ? "10px" : "42px",
                marginTop: "45px",
                width: isMobile ? "100%" : "auto",
                maxWidth: isMobile ? "320px" : "none",
              }}
            >
              {[
                ["98%", "Automation"],
                ["24/7", "Support"],
                ["10+", "ERP Modules"]

              ].map((item, index) => (
                <div key={index}>
                  <h3
                    style={{
                      color: "#55FF60",
                      fontSize: isMobile ? "18px" : "30px",
                    }}
                  >
                    {item[0]}
                  </h3>
                  <p
                    style={{
                      color: "rgba(255,255,255,0.65)",
                      fontSize: "14px",
                    }}
                  >
                    {item[1]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Video Modal */}
        {showVideo && createPortal(
          <div
            onClick={() => {
              setShowVideo(false);
            }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.85)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 99999,
              padding: "20px",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                width: isMobile ? "100%" : "90%",
                maxWidth: "1000px",
                borderRadius: isMobile ? "12px" : "20px",
                overflow: "hidden",
                boxShadow: "0 20px 80px rgba(0,0,0,0.6)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: "56.25%",
                  height: 0,
                }}
              >
                <iframe
                  src={youtubeEmbedUrl}
                  title="GTELINQ Demo Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                />
              </div>

              <div
                style={{
                  padding: "15px",
                  textAlign: "center",
                  background: "#111",
                }}
              >
                <a
                  href="https://youtu.be/cu4SwU5JeAA"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#55FF60",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  Watch on YouTube →
                </a>
              </div>
            </div>
          </div>,
          document.body
        )}
      </section>
    </>
  );
};

export default SplineRobot;

